import { TextIconGroupListCombinedProps } from './types';

const usePresenter = (props: TextIconGroupListCombinedProps): TextIconGroupListCombinedProps => {
  return props;
};

export default usePresenter;
